import { FC, useState } from 'react';

import FiltersDropdown from '@/components/FilterDropdown';
import FilterButton from '@/components/FilterDropdown/FilterButton';
import FilterRadioButton from '@/components/FilterDropdown/FilterRadioButton';
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from '@/components/FilterDropdown/Parts';

interface Props {
  setQueueStatus: React.Dispatch<React.SetStateAction<null | boolean>>;
  queueStatus: null | boolean;
}

const QueueStatusFilter: FC<Props> = ({ queueStatus, setQueueStatus }) => {
  const [show, setShow] = useState(false);

  return (
    <FilterWrap>
      <FilterButton
        text="Queue"
        isActive={show}
        onClick={(e) => {
          e?.stopPropagation();
          setShow((prev) => !prev);
        }}
        filterApplied={queueStatus !== null}
      />
      {show && (
        <FiltersDropdown onClose={() => setShow(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>Queue status</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            <FilterRadioButton
              id={`queueStatus-1`}
              value={''}
              checked={queueStatus === null}
              setValue={() => setQueueStatus(null)}
            >
              All
            </FilterRadioButton>
            <FilterRadioButton
              id={`queueStatus-2`}
              value={'1'}
              checked={!!queueStatus}
              setValue={() => setQueueStatus(true)}
            >
              Enabled
            </FilterRadioButton>
            <FilterRadioButton
              id={`queueStatus-3`}
              value={'2'}
              checked={queueStatus === false}
              setValue={() => setQueueStatus(false)}
            >
              Disabled
            </FilterRadioButton>
          </FilterGroupBody>
        </FiltersDropdown>
      )}
    </FilterWrap>
  );
};

export default QueueStatusFilter;
